(function () {
    document.addEventListener("DOMContentLoaded", function () {
        let anchors = [];
        document.querySelectorAll(".anchor").forEach((el) => {
            anchors.push(el);
            el.addEventListener("click", function () {
                StickyPageNavAnchorClickHandler(el);
            });
        });
        if (anchors && anchors.length > 0) {
            window.addEventListener("scroll", function () {
                StickyPageNavScrollHandler(anchors);
            });
        }
    })
})();

function StickyPageNavScrollHandler(anchors) {
    if (document.querySelector(".page-subnavigation")) {
        let navigationOffset = document.querySelector(".page-subnavigation").getBoundingClientRect().top;
        let offsets = [];

        anchors.forEach((el) => {
            let target = document.querySelector(el.getAttribute("href"));
            var viewportOffset = target.getBoundingClientRect();
            var top = viewportOffset.top;
            offsets.push(top);
        });

        let closest = offsets.reduce(function (prev, curr) {
            return (Math.abs(curr - navigationOffset) < Math.abs(prev - navigationOffset) ? curr : prev);
        });

        let active = anchors[offsets.indexOf(closest)];

        document.querySelectorAll(".anchor").forEach((el) => {
            el.classList.remove("active");
        });

        active.classList.add("active");
    }
}

function StickyPageNavAnchorClickHandler(el) {
    var element = document.querySelector(el.getAttribute("href"));

    var headerOffset = 100;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
    });

    return false;
}